/* iter55u — Extracted from AppShell.jsx.
 *
 * The initial connecting-to-Claude splash screen shown while
 * `usePW().loading` is truthy or the active project hasn't loaded.
 */
import React from 'react';
import { useTranslation } from 'react-i18next';   // Feb-2026 · i18n Wave 5
import { BookOpen, Loader2 } from 'lucide-react';

export default function AppLoadingSplash() {
  const { t } = useTranslation();
  return (
    <div className="flex h-full w-full items-center justify-center bg-background text-foreground">
      <div className="flex flex-col items-center gap-3 text-center">
        <div className="relative">
          <div className="flex h-14 w-14 items-center justify-center rounded-md bg-gradient-to-br from-primary to-primary/70 text-primary-foreground shadow-panel-active">
            <BookOpen className="h-6 w-6" strokeWidth={2.25} />
          </div>
          <Loader2 className="absolute -bottom-1 -right-1 h-4 w-4 animate-spin text-primary" />
        </div>
        <div>
          <div className="text-[11px] uppercase tracking-[0.22em] text-muted-foreground">The Loom</div>
          <div className="text-lg font-semibold">{t('common.loading')}</div>
        </div>
      </div>
    </div>
  );
}
